import {
  IVitalListEmptyEntry,
  IVitalListEntry,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import getGraphData from '../get-graph-data';
import { getDetailRowProps } from '../get-detail-row-props';
import updateBarChartProps from '../updateBarChartProps';
import {
  BarSegmentChartProps,
  IBarSegmentConfig,
} from '../../../components/bar-segment-chart/bar-segment-chart';
import { GENDER_MALE, TGenderType } from '@hilbi/web-common/types/common';
import { WAIST_BAR_CHART_CONFIG, WAIST_BAR_CHART_CONFIG_FEMALE } from './waist.entry.data';
import getBadgeProps from '../get-badge-props';

/**
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 * @param gender TGenderType
 */
export default function waistEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
  gender: TGenderType,
): IVitalListEntry | IVitalListEmptyEntry {
  const barChartWidgetConfig =
    gender === GENDER_MALE ? WAIST_BAR_CHART_CONFIG : WAIST_BAR_CHART_CONFIG_FEMALE;

  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/waist-circumference.svg').default,
    title: 'life_id.waist',
    barChartWidgetProps: config.WAIST.barchartWidget?.barChartWidgetProps as BarSegmentChartProps,
  };

  if (!vitalDataSettings || !vitalData || !vitalData.waistCircumference) {
    return emptyEntry;
  }

  const settings = [vitalDataSettings.waistCircumference];
  const lastRecord = vitalData.waistCircumference.lastRecord;

  const barChartWidgetProps = updateBarChartProps(
    barChartWidgetConfig as IBarSegmentConfig,
    lastRecord,
  );

  const entry = {
    ...emptyEntry,
    modalType: 'WAIST' as const,
    isEmpty: false,
    average: vitalData.waistCircumference.average || '-',
    status: `life_id:status.${lastRecord.status}`,
    ...getBadgeProps(vitalData.waistCircumference.lastRecord.source),
    getDetailRowProps: getDetailRowProps(
      settings,
      config.WAIST.valueSelectors[0] as keyof TVitalDataSearchItem,
    ),
    summaryChartProps: {
      oneSidedRange: false,
      unit: `units.${config.WAIST.unit}`,
      value: lastRecord.waistCircumference || '-',
      ...getGraphData(settings, [lastRecord.waistCircumference]),
    },
    urlPart: config.WAIST.urlPart,
    barChartWidgetProps,
  };

  return entry;
}
